import Work1 from '../../assets/work-1.svg';
import Work2 from '../../assets/work-2.svg';
import Work3 from '../../assets/work-3.svg';
import Work4 from '../../assets/work-4.svg';

const Menu = [
    {
      id: 1,
      image: Work1,
      title: "Landing Page - Minur",
      category: "Javascript",
    },
    {
      id: 2,
      image: Work2,
      title: "Crypto App - Figma",
      category: "Design",
    },
    {
      id: 3,
      image: Work3,
      title: "Simple To-Do List",
      category: "Javascript",
    },
    ,
    {
      id: 4,
      image: Work4,
      title: "Simple Calculator App",
      category: "Mobile",
    },
  ];

  export default Menu;